<template>
  <v-form v-model="valid" ref="form">
    <v-card color="#284e3c" class="white--text">
      <v-divider class="mx-2" inset horizontal></v-divider>
        <v-card-title>
          <v-icon color="white" large left>face</v-icon>
          <span class="title font-weight-heavy">Edit User '{{ user.username }}' Details
            <button type="button" class="btn btn-secondary" data-toggle="tooltip" data-placement="left" title="If you wish to edit fields simply type in the appropriate box.  If you do not wish to edit certain fields do not change the appropriate field.">
                <v-icon color="white" large right>help_outline</v-icon>
            </button>
          </span>
        </v-card-title>
        <v-card-title>
          <!-- possible to change current user details to 'readonly' -->
          <!-- Token needs to be changed when username is changed! -->
          <span><v-text-field v-model="user.username" :rules="rules.name" class="title font-weight-heavy" color='white' label='Name:'></v-text-field></span>
          <span><v-divider class="mx-12" inset horizontal></v-divider></span>
          <span><v-text-field v-model="user.email" :rules="rules.email" class="title font-weight-heavy" color='white' label='Email:'></v-text-field></span>
        </v-card-title>
        <v-card-title>
          <span><v-text-field v-model="user.sms" type='phone' class="title font-weight-heavy" color='white' label='Contact Number:'></v-text-field></span>
        </v-card-title>
        <v-card-title>
          <span><v-divider class="mx-12" inset horizontal></v-divider></span>
          <span><v-divider class="mx-12" inset horizontal></v-divider></span>
          <span><v-divider class="mx-12" inset horizontal></v-divider></span>
          <span><v-divider class="mx-12" inset horizontal></v-divider></span>
          <span><v-divider class="mx-12" inset horizontal></v-divider></span>
          <span><v-divider class="mx-12" inset horizontal></v-divider></span>
          <span><v-divider class="mx-12" inset horizontal></v-divider></span>
          <span><v-divider class="mx-12" inset horizontal></v-divider></span>
          <span>
          <v-btn name="SaveChangesBtn" v-on:click="SaveChanges" :disabled="!valid" color="info">Save Changes</v-btn>
          <v-btn name="CancelChangesBtn" v-on:click="CancelChanges" color="warning" type="submit">Cancel Changes</v-btn>
          </span>
        </v-card-title>
        <v-divider class="mx-2" inset horizontal></v-divider>
    </v-card>
  </v-form>
</template>
<script>
export default {
  computed: {
    rules () {
      return {
        name: [
          (v) => !!v || 'Name is required'
        ],
        email: [
          // eslint-disable-next-line no-useless-escape
          (v) => /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'E-mail must be valid'
        ]
      }
    }
  },
  name: 'UserDetails',
  props: {
    userID: {
      type: Number,
      default: null
    }
  },
  data: () => ({
    user: {
      username: '',
      sms: '',
      email: ''
    },
    error: '',
    valid: false
  }),
  methods: {
    CancelChanges () {
      this.$router.go()
    },
    SaveChanges () {
      var url = `/schemas/users/${this.userID}`
      this.$http
        .put(url,
          {
            'username': `${this.user.username}`,
            'email': `${this.user.email}`,
            'sms': `${this.user.sms}`
          }
        )
        .then(response => {
          this.UserUpdated(response.data.user)
        })
        .catch(error => this.putUserRequestFailed(error))
    },
    UserUpdated (user) {
      // eslint-disable-next-line no-console
      // console.log(`Updated User: ${user.username}`)
      this.$router.go()
    },
    putUserRequestFailed (error) {
      this.error = 'Failed to update user data'
      // eslint-disable-next-line
      console.log(error)
      this.$parent.$emit('error', this.error)
    },
    getUserDetails () {
      var url = `/schemas/users/${this.userID}`
      // Get User information
      this.$http
        .get(url)
        .then(response => {
          this.user = response.data.user
        })
        .catch(error => this.getUserRequestFailed(error))
    },
    getUserRequestFailed (error) {
      this.error = 'Failed to retrieve user data'
      // eslint-disable-next-line
      console.log(error)
      this.$parent.$emit('error', this.error)
    }
  },
  beforeMount () {
    this.getUserDetails()
  }
}
</script>
